module.exports = __webpack_public_path__ + "img/Main_grid_square_GE.2d3a1aaf.jpg";